import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=aa520c12&scoped=true&"
import script from "./UiCheckbox.vue?vue&type=script&lang=js&"
export * from "./UiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=aa520c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa520c12",
  null
  
)

export default component.exports